import React from "react";
import "./UserFields.scss";
import LabeledInput from "./LabeledInput";

function UserFields({ fields, control, register, errors, prefix, userData = {}, watchCountry }) {
  return fields.map((field, i) => (
    <div key={i} className="field-wrapper">
      {field ? (
        <LabeledInput
          fieldInfo={field}
          control={control}
          register={register}
          errors={errors}
          prefix={prefix}
          userData={userData}
          watchCountry={watchCountry}
        />
      ) : (
        <div />
      )}
    </div>
  ));
}

export default UserFields;
